<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.association', 1) }}
                    </h3>
                </div>
            </div>

            <div class=" " :class="[ mobileView ? 'pt-3': 'card-body']">
                <b-form  @reset="onReset" v-if="show">
                    <div class=" " :class="[ mobileView ? '': 'container']">
                        <b-row>
                            <b-col sm="12">

                                <b-form-group
                                        id="prenom-group"
                                        :label="$t('message.name')"
                                        label-for="nom"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nomContact.$model"
                                            type="text"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire justify-center">*</span>

                                <b-form-group
                                        id="single-group"
                                        :label="$t('message.select')+' '+$tc('message.region', 1)"
                                        label-for="regions">
                                    <!-- Options -->
                                    <select id="regions"  v-model="$v.form.regions.$model "
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.regions.$dirty ? !(errorshasField('regions') || $v.form.regions.$error) : null"

                                            required>
                                        <option v-for="item in mRegions" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="errorshasField('regions')">
                                        {{ getErrorsField('regions') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.regions.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>
                            </b-row>
                            <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nom-group"
                                        :label="$tc('message.cities',1)"
                                        label-for="ville"
                                        description=""

                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="$v.form.ville.$model"
                                            :state="$v.form.ville.$dirty ? !(errorshasField('ville') || $v.form.ville.$error) : null"
                                            type="text"
                                            placeholder=""
                                            @focus="clearErrorField('ville')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback  v-if="!$v.form.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            </b-row>
                            <b-row>
                            </b-row>
                            <b-row>
                            <b-col sm="12">

                                <b-form-group
                                        id="prenom-group"
                                        :label="$t('message.address')"
                                        label-for="nom"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.localisation.$model"
                                            type="text"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            </b-row>
                            <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <b-form-input
                                            id="telephone"
                                            v-model="$v.form.telephone.$model"
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
<!--                                    <b-form-invalid-feedback v-if="!$v.form.telephone.integer">-->
<!--                                        {{ $t('message.integer', { n: 9 }) }}-->
<!--                                    </b-form-invalid-feedback>-->
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.numeric">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            </b-row>
                            <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.email.$model"
                                            :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                                            type="email"
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            </b-row>

                    </div>
                    <b-container>
                        <b-row class="justify-content-center" v-if="can">
                            <b-button  variant="primary" @click="onSubmit">
                                {{ $t('message.save') }}
                            </b-button>
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength,integer,numeric,maxLength} from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "AddAssociation",
        filters: {
            capitalize: function (value) {
                if (!value) return '';
                value = value.toString().toUpperCase();
                return value;
            }
        },
        computed: {
            ...mapGetters(["institutions", "professions", "regions", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },
            mRegions: function() {
                let cArray = [];

                _.forOwn(this.regions, function(value, key) {
                    cArray.push({ text: value.fr_description, value: value.fr_description });
                });
             
                return cArray;
            },
            mPartenaires: function() {
                let cArray = [];

                _.forOwn(this.associations, function(value, key) {
                    cArray.push({ text: value.fr_description, value: value.fr_description });
                });
//    console.log(cArray);
                return cArray;
            },
        },

        data() {
            return {
                mobileView: true,
                form: {
                    regions: [],
                    telephone: '',
                    email: '',
                    contact: '',
                    localisation: '',
                    ville: '',
                    localisation: '',
                    NomContact: ''
                },
                show: true,


            }
        },

        watch: {
            $v: {
                handler: function (val) {
                    if(!val.$invalid) {
                        //
                    }
                }
            },
        },

        methods: {
            handleView() {
            this.mobileView = window.innerWidth < 991;
            },
            getRegions: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getRegions', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();
                this.$v.$touch();
                if(!this.$v.$invalid) {

                    let formData = new FormData();

                    //formData.append('contact', this.form.nomContact);
                    formData.append('region', this.form.regions);
                    formData.append('nom', this.form.nomContact);
                    formData.append('email', this.form.email);
                    formData.append('telephone', "237"+this.form.telephone,);
                    formData.append('ville', this.form.ville);
                    formData.append('localisation', this.form.localisation);

                    let successMessage = this.$i18n.t('message.associationCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createAssociation', { args:formData, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
                else{
                    // console.log(this.$v.$invalid)
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.nomContact = '';
                this.form.associations = '';
                this.form.regions = '';
                this.form.email = '';
                this.form.telephone = '';
                this.form.ville = '';
                this.form.localisation = '';
                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                nomContact: {
                    required
                },

                localisation: {
                    required
                },
                telephone: {
                    required,
                    minLength: minLength(9),
                    numeric
                },
                email: {
                    required,
                    email
                },
                regions: {
                    required,
                },
                ville: {
                    required
                },
            }
        },
        created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
        },
        mounted() {
            // Retrieve list of countries
            this.getRegions();

            // Retrieve list of specialties
            //this.getPartenaires();
            new SlimSelect({
                select: '#regions'
            });
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');

</style>